<template>
  <nuxt-link :to="link" class="action-card" :class="{'action-card--full-width': fullWidth}" target="_blank" @click="emits('click')">
    <div class="action-card__image">
      <nuxt-img
        :src="cover"
        format="webp"
        sizes="500px"
        loading="lazy"
      ></nuxt-img>
    </div>
    <div class="action-card__content builder-block" :style="{
      backgroundColor: backgroundColor || undefined,
      color: textColor || undefined
    }">
      <mks-heading tag="h4" class="action-card__title">{{ title }}</mks-heading>
      <mks-text tag="p" class="action-card__text" v-html="text"></mks-text>
      <mks-button class="action-card__button" size="small" :style="{
        borderColor: buttonColor || undefined,
        backgroundColor: buttonColor || undefined,
        color: arrowColor || undefined
      }">
        <long-arrow width="35" />
      </mks-button>
    </div>
  </nuxt-link>
</template>

<script setup>
import longArrow from '@/assets/icons/arrow-long.svg';

const props = defineProps({
  cover: String,
  title: String,
  text: String,
  link: String,
  backgroundColor: String,
  textColor: String,
  buttonColor: String,
  arrowColor: String,
  fullWidth: Boolean
});

const emits = defineEmits(['click'])
</script>

<style lang="scss" scoped>
.action-card {
  position: relative;
  max-width: 400px;
  border-radius: 30px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-bottom: $space-l;

  &__image {

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      aspect-ratio: 400 / 228;
    }
  }

  &__content {
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: $space-m;
  }

  &__title {
    font-family: $font-heading;
    font-weight: $font-weight-black;
    font-size: 1.375rem;
    margin-bottom: $space-s;
  }
  &__text {
    margin-bottom: $space-s;
  }

  &__button {
    padding: $space-xs $space-s;
    line-height: 0;
  }

  &--full-width {
    max-width: none;
  }

  @include breakpoint('small', 'min') {
    &__title {
      font-size: 1.685rem;
      margin-bottom: $space-m;
    }
    &__content {
      padding: $space-l;
    }
  }
}
</style>
